export const CheckIcon = ({
  width = 736,
  height = 736,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 736 736"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M368 735.5C570.965 735.5 735.5 570.965 735.5 368C735.5 165.035 570.965 0.5 368 0.5C165.035 0.5 0.5 165.035 0.5 368C0.5 570.965 165.035 735.5 368 735.5Z"
        fill="black"
      />
      <path
        d="M690.27 365.91C691.36 542.1 548.01 688.44 372.5 690.32C193.38 692.24 46.72 548.47 45.73 370.01C44.75 193.33 187.41 47.7 363.44 45.69C542.52 43.64 689.17 187.33 690.27 365.92V365.91ZM322.27 423.87C305.12 407.78 293.78 390.47 278.05 384.19C260.86 377.33 239.6 380.69 220.11 379.59C220.03 399.04 212.25 424.02 221.43 436.83C242.65 466.44 269.43 494.07 299.42 514.48C312.87 523.63 350.49 521.56 358.25 510.87C416.34 430.85 470.92 348.15 522.95 264.03C529.25 253.84 518.57 224.44 506.83 214.71C498.39 207.71 472.92 214.84 459.1 222.74C447.26 229.51 440.96 246.2 432.56 258.73C396.42 312.69 360.41 366.74 322.27 423.87Z"
        fill="#FBED21"
      />
    </svg>
  );
};
